import React from "react";

function Info({ children, content, link }) {
  return (
    <div className="d-flex align-items-center gap-3  ">
      <span className="text-secondary ">{children}</span>
      <div className="d-block">
        <h4 className="fs-6 fw-semibold ">{content.title}</h4>
        <p className="m-0 fs-6 text-black-50 fw-normal  special-hover-color dark-text">
          {link ? (
            <a href={`mailto:${content.content}`}>{content.content}</a>
          ) : (
            content.content
          )}
        </p>
      </div>
    </div>
  );
}

export default Info;
